import React from 'react';

const Utilities = () => {
    return (
        <div className="industry-section">
            <div className="industry-content">
                <h2>Utilities</h2>
                <p>
                    Transform utility infrastructure management with our advanced LiDAR solutions. We provide comprehensive mapping of power lines, pipelines, and other critical utility assets with millimeter precision, enabling better maintenance planning and risk assessment.
                </p>
                <p>
                    Our 3D models help identify vegetation encroachment, structural issues, and potential hazards before they cause disruptions, improving reliability and safety while reducing operational costs.
                </p>
                <div className="industry-features">
                    <span className="feature-item">Power Line Inspection</span>
                    <span className="feature-item">Vegetation Management</span>
                    <span className="feature-item">Pipeline Monitoring</span>
                    <span className="feature-item">Substation Modeling</span>
                    <span className="feature-item">Risk Assessment</span>
                </div>
            </div>
            <div className="industry-image">
                <img src="/img/industries/utilities.png" alt="Utilities LiDAR Application" />
            </div>
        </div>
    );
};

export default Utilities;
